import { actionsPreprocessor } from '../../utils/redux';

const actionNames = [
  'PREV_STEP',
  'NEXT_SUBMIT',
  'SAVE_STEP_DATA',

  'SUBMIT_FORM',
  'SUMMARY_SUBMIT_SUCCESS',
  'STEP2_SUBMIT_SUCCESS',
  'SUBMIT_ERROR',

  'FILE_UPLOAD',
  'FILE_UPLOAD_SUCCESS',
  'FILE_UPLOAD_ERROR',
  'FILE_REMOVE',
  'FILE_REMOVE_SUCCESS',

  'SAVE_UAPI_REFERRAL_ID',
  'UTILITY_API_AUTH',

  'FETCH_UAPI_DATA',
  'FETCH_UAPI_SUCCESS',
  'FETCH_UAPI_FAILED',

  'FETCH_UAPI_FILES',
  'FETCH_UAPI_FILES_SUCCESS',
  'FETCH_UAPI_FILES_FAILED',

  'INIT_NEW_LEAD',

  'FETCH_LEAD_ENRICHMENT_STATUS',
  'FETCH_LEAD_ENRICHMENT_SUCCESS',
  'FETCH_LEAD_ENRICHMENT_FAILED',
];

const { actions, actionTypes } = actionsPreprocessor('intakeForm', actionNames);

export default actions;
export { actionTypes };
